import React from 'react';
import PostBoostBenefit from './PostBoostBenefit';
import styles from './postboost.module.scss';

const PostBoostBenefits = () => {
  return (
    <div className={styles.boostBenefitsBox}>
      <PostBoostBenefit
        number={1}
        benefit={'Get 3 times more top tier applicants'}
      />
      <PostBoostBenefit
        number={2}
        benefit={'Job placed at the top of search results'}
      />
      <PostBoostBenefit
        number={3}
        benefit={
          'Featured in our daily digest job alerts promoted to our network of verified freelancers!'
        }
      />
    </div>
  );
};

export default PostBoostBenefits;
